/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){

	function initEventListeners(){

		pipEvents.appliance.applianceError.on(function(evtType, data){
			pushAnalyticsErrorEvent(data);
		});

    pipEvents.appliance.applianceAvailabilityCheckedV3.on(function(evtType, data) {

      return createAnalyticsEventsV3(evtType, data);
    });
    pipEvents.appliance.applianceAvailabilityChecked.on(function(evtType, data) {
      return createAnalyticsEvents(evtType, data);
    });

  }
  // TODO: Once the feature switch is removed, this stash param
  // and usuage of it should be named "isButtonSubmission"
  function pushAnalyticsEvent(item, stash) {
    var analyticsObject;
    if (stash) {
      item.productInfo.isBundled = false;
      analyticsObject = {
            stash: {
                item: Array.isArray(item) ? item : [item],
            },
            category: {
                primaryCategory: 'stash'
            },
            eventInfo: {
                eventName: 'check fulfillment availability',
            },
            eventMode: 'stash'
        };
    } else {
      analyticsObject = {
            item: [item],
            category: {
                primaryCategory: 'button submission'
            },
            eventInfo: {
                eventName: 'check fulfillment availability',
            }
        };
    }

    if (pip.debugMode) {
      console.log('DDO Appliance Event', analyticsObject);
    }
    if (window.digitalData && window.digitalData.event) {
      window.digitalData.event.push(analyticsObject);
    }
  }

	function pushAnalyticsErrorEvent(error){

		var analyticsObject ={
			category:{
				primaryCategory: 'error'
			},
			eventInfo: {
				eventName: 'post page error',
				error: [error]
			}
		};

		if (pip.debugMode) {
      console.log('DDO Appliance Error Event', analyticsObject);
    }

		if (window.digitalData && window.digitalData.event) {
      window.digitalData.event.push(analyticsObject);
    }

  }
  function createAnalyticsEvents(evtType, data){
      if (data.processedResponse.isError) {
          pushAnalyticsErrorEvent({
              type: 'system',
              displayType: 'inline',
              pageSection: 'pip',
              message: "Sorry, an error occurred.",
              code: data.rawResponse.deliveryAvailabilityResponse
                      && data.rawResponse.deliveryAvailabilityResponse.errorData
                      && data.rawResponse.deliveryAvailabilityResponse.errorData.errors
                      && data.rawResponse.deliveryAvailabilityResponse.errorData.errors.error
                      && data.rawResponse.deliveryAvailabilityResponse.errorData.errors.error.errorCode
          })
      } else {
        pushAnalyticsEvent({
            productInfo: {
                sku: pip.products.primary.data.itemId,
                eta: {
                    applStartDate: data.processedResponse.rawDeliveryDate || data.processedResponse.rawBackOrderedEstimatedDeliveryDate,
                    applEndDate: data.processedResponse.rawEndDeliveryDate
                },
                availabilityStatus: {
                    backOrder: data.processedResponse.isBackOrdered,
                    inStockAppl: data.processedResponse.isAvailable && !data.processedResponse.isOutOfStock
                }
            },
            fulfillment: {
                method: "appl",
                zip: data.processedResponse.zipCode
            },
        }, data.stash)
      }

  }
  function createAnalyticsEventsV3(evtType, data){
      if (data.processedResponse[0].isError) {
          return pushAnalyticsErrorEvent({
              type: 'system',
              displayType: 'inline',
              pageSection: 'pip',
              message: "Sorry, an error occurred.",
              code: data.rawResponse.DeliveryAvailabilityResponse
                      && data.rawResponse.DeliveryAvailabilityResponse.errorData
                      && data.rawResponse.DeliveryAvailabilityResponse.errorData.errors
                      && data.rawResponse.DeliveryAvailabilityResponse.errorData.errors.error
                      && data.rawResponse.DeliveryAvailabilityResponse.errorData.errors.error.errorCode
              })
      }

      var response = data.processedResponse[0];
      var isButtonSubmission = response.isOutOfStock || response.isBackOrdered;
      var eventInformation = {
          productInfo: {
              sku: pip.products.primary.data.itemId,
              eta: {
                  applStartDate: response.deliveryDate || response.backOrderedEstimatedDeliveryDate,
                  applEndDate: response.endDeliveryDate
              },
              availabilityStatus: {
                  backOrder: response.isBackOrdered,
                  inStockAppl: response.isAvailable && !response.isOutOfStock
              }
          },
          fulfillment: {
              method: "appl",
              zip: data.processedResponse[0].zipCode
          },
      };

      return pushAnalyticsEvent({
          productInfo: {
              sku: pip.products.primary.data.itemId,
              eta: {
                  applStartDate: data.processedResponse[0].deliveryDate || data.processedResponse[0].backOrderedEstimatedDeliveryDate,
                  applEndDate: data.processedResponse[0].endDeliveryDate
              },
              availabilityStatus: {
                  backOrder: data.processedResponse[0].isBackOrdered,
                  inStockAppl: data.processedResponse[0].isAvailable && !data.processedResponse[0].isOutOfStock
              }
          },
          fulfillment: {
              method: "appl",
              zip: data.processedResponse[0].zipCode
          },
      }, data.stash);
  }

	return {
		init: function(){
			initEventListeners();
		}
	}

});

}.call(window));